/* eslint-disable prettier/prettier */
import { TextField, IconButton, Icon, Tooltip } from '@nike/eds';
import React, {
  ChangeEvent,
  useState,
  RefObject,
  useRef,
  memo,
  useEffect,
} from 'react';

type ChangeItems = {
  image: UploadFileType | null;
  isPortrait: boolean;
  itemIndex: number;
  imageUrl: string;
  preSignedUrl?: string;
  src: string;
};

type ChangeTitleItems = {
  title: string;
  deepLink: string;
  liveText?: string;
};

type RankingListPreviewItemProps = {
  item: RankingItem | null;
  itemIndex: number;
  portraitItemChange: (
    image: UploadFileType | null,
    isPortrait: boolean,
    itemIndex: number,
    src: string,
  ) => void;
  portraitTitleAndDeepLinkChange: (
    title: string,
    deepLink: string,
    itemIndex: number,
  ) => void;
  squarishTitleAndDeepLinkAndLiveTextChange: (
    title: string,
    deepLink: string,
    livText: string,
    itemIndex: number,
  ) => void;
  handleDeleteItem: (itemIndex: number) => void;
};

type RankingListPreviewProps = {
  itemsList: RankingItem[];
};

const RankingListItem = React.forwardRef(
  (props: RankingListPreviewProps, ref: any) => {
    useEffect(() => {
      console.log('load child component', props);
    });

    const methodToCall = () => {
      // update title deepLink and liveText
      for (const key in changeTitleItems) {
        const currentIndex = parseInt(key);
        itemsList[currentIndex].deepLink =
          changeTitleItems[currentIndex].deepLink;
        itemsList[currentIndex].title = changeTitleItems[currentIndex].title;
        itemsList[currentIndex].liveText =
          changeTitleItems[currentIndex].liveText;
      }
      // update itemList url
      for (const [key, value] of Object.entries(changeItems)) {
        const currentIndex = value.itemIndex;
        const isPortrait = value.isPortrait;
        if (isPortrait) {
          itemsList[currentIndex].image.portraitURL = value.src;
        }
        if (!isPortrait) {
          itemsList[currentIndex].image.squarishURL = value.src;
        }
      }
      console.log('child component method is called', itemsList);
      return [itemsList, changeItems];
    };

    // expose method to parent component
    React.useImperativeHandle(ref, () => ({
      methodToCall,
    }));

    const initItemList = () => {
      let initItemLists: RankingItem[] = [];
      if (props.itemsList.length == 0) {
        const emptyProductItem: RankingItem = {
          rank: 1,
          title: '',
          deepLink: '',
          catalogId: '',
          styleColor: '',
          imageUrl: '',
          portraitURL: '',
          liveText: '',
          image: {
            portraitURL: '',
            squarishURL: '',
          },
          background: {
            portraitURL: '',
            squarishURL: '',
          },
          isAddPortrait: true,
          isLive: false,
        };
        const emptyLiveItem: RankingItem = {
          rank: 1,
          title: '',
          deepLink: '',
          catalogId: '',
          styleColor: '',
          imageUrl: '',
          portraitURL: '',
          liveText: '',
          image: {
            portraitURL: '',
            squarishURL: '',
          },
          background: {
            portraitURL: '',
            squarishURL: '',
          },
          isAddPortrait: false,
          isLive: true,
        };
        initItemLists.push(emptyProductItem);
        initItemLists.push(emptyLiveItem);
      } else {
        initItemLists = props.itemsList;
      }
      return initItemLists;
    };
    const emptyProductItem: RankingItem = {
      rank: 1,
      title: '',
      deepLink: '',
      catalogId: '',
      styleColor: '',
      imageUrl: '',
      portraitURL: '',
      liveText: '',
      image: {
        portraitURL: '',
        squarishURL: '',
      },
      background: {
        portraitURL: '',
        squarishURL: '',
      },
      isAddPortrait: true,
      isLive: false,
    };
    const emptyLiveItem: RankingItem = {
      rank: 1,
      title: '',
      deepLink: '',
      catalogId: '',
      styleColor: '',
      imageUrl: '',
      portraitURL: '',
      liveText: '',
      image: {
        portraitURL: '',
        squarishURL: '',
      },
      background: {
        portraitURL: '',
        squarishURL: '',
      },
      isAddPortrait: false,
      isLive: true,
    };
    const [itemsList, setItemsList] = useState<RankingItem[]>(initItemList());

    const [changeItems, setChangeItems] = useState<Record<string, ChangeItems>>(
      {},
    );
    const [changeTitleItems, setChangeTitleItems] = useState<
      Record<number, ChangeTitleItems>
    >({});

    const portraitItemChange = (
      image: UploadFileType | null,
      isPortrait: boolean,
      itemIndex: number,
      src: string,
    ) => {
      console.log('setUploadImageItems change');
      console.log(image);
      console.log(isPortrait);
      console.log(itemIndex);
      itemsList.map((item, index) => {
        if (index != itemIndex) {
          return;
        }
        //isPortrait ? item.image.portraitURL
        const urlSuffix = isPortrait ? '-portrait-' : '-squarish-';
        changeItems[index + urlSuffix] = {
          image: image,
          isPortrait: isPortrait,
          itemIndex: itemIndex,
          imageUrl: '',
          src: src,
        };
        console.log(changeItems);
        setChangeItems(changeItems);
      });
      console.log('changeItems', changeItems);
      //uploadImagesBeforeSubmit();
    };

    const portraitTitleAndDeepLinkChange = (
      title: string,
      deepLink: string,
      itemIndex: number,
    ) => {
      changeTitleItems[itemIndex] = {
        title,
        deepLink,
      };
      //setChangeTitleItems(changeTitleItems);
      console.log('after add portrait ', changeTitleItems);
    };

    const squarishTitleAndDeepLinkAndLiveTextChange = (
      title: string,
      deepLink: string,
      liveText: string,
      itemIndex: number,
    ) => {
      changeTitleItems[itemIndex] = {
        title,
        deepLink,
        liveText,
      };
      //setChangeTitleItems(changeTitleItems);
      console.log('after add squarish ', changeTitleItems);
    };

    const handleDeleteItem = (itemIndex: number) => {
      // reindex before delete
      // key = 2-squarish-
      const newChangeItems: Record<string, ChangeItems> = {};
      for (const key in changeItems) {
        const changeIndex = changeItems[key].itemIndex;
        // delete equals
        if (changeIndex == itemIndex) {
          continue;
        } else if (itemIndex < changeIndex) {
          const newKey = key.replace(changeIndex + '', changeIndex - 1 + '');
          newChangeItems[newKey] = changeItems[key];
          newChangeItems[newKey].itemIndex = changeIndex - 1;
        } else if (itemIndex > changeIndex) {
          newChangeItems[key] = changeItems[key];
        }
      }
      setChangeItems(newChangeItems);

      const newTitleChangeItems: Record<number, ChangeTitleItems> = {};
      for (const key in changeTitleItems) {
        const changeIndex = parseInt(key);
        // delete equals
        if (changeIndex == itemIndex) {
          continue;
        } else if (itemIndex < changeIndex) {
          newTitleChangeItems[changeIndex - 1] = changeTitleItems[key];
        } else if (itemIndex > changeIndex) {
          newTitleChangeItems[key] = changeTitleItems[key];
        }
      }
      setChangeTitleItems(newTitleChangeItems);
      console.log('handleDeleteitem', itemIndex);
      // const updatedItems = [...itemsList];
      const newItemList: RankingItem[] = [];
      itemsList.map((item, index) => {
        if (index != itemIndex) {
          newItemList.push(item);
        }
      });

      // update title deepLink and liveText
      for (const key in newTitleChangeItems) {
        const currentIndex = parseInt(key);
        newItemList[currentIndex].deepLink =
          newTitleChangeItems[currentIndex].deepLink;
        newItemList[currentIndex].title =
          newTitleChangeItems[currentIndex].title;
        if (changeTitleItems[currentIndex]) {
          newItemList[currentIndex].liveText =
            newTitleChangeItems[currentIndex].liveText;
        }
      }

      // update itemList url
      for (const [key, value] of Object.entries(newChangeItems)) {
        const currentIndex = value.itemIndex;
        const isPortrait = value.isPortrait;
        if (isPortrait) {
          newItemList[currentIndex].image.portraitURL = value.src;
        }
        if (!isPortrait) {
          newItemList[currentIndex].image.squarishURL = value.src;
        }
      }

      console.log('after delete ', newItemList);

      console.log('after delete changeItems ', changeItems);

      console.log('after delete changeTitleItems ', changeTitleItems);

      setItemsList(newItemList);
    };

    const addItem = (isAddPortrait: boolean) => {
      // update title deepLink and liveText
      for (const key in changeTitleItems) {
        const currentIndex = parseInt(key);
        itemsList[currentIndex].deepLink =
          changeTitleItems[currentIndex].deepLink;
        itemsList[currentIndex].title = changeTitleItems[currentIndex].title;
        itemsList[currentIndex].liveText =
          changeTitleItems[currentIndex].liveText;
      }
      // update itemList url
      for (const [key, value] of Object.entries(changeItems)) {
        const currentIndex = value.itemIndex;
        const isPortrait = value.isPortrait;
        if (isPortrait) {
          itemsList[currentIndex].image.portraitURL = value.src;
        }
        if (!isPortrait) {
          itemsList[currentIndex].image.squarishURL = value.src;
        }
      }

      if (isAddPortrait) {
        setItemsList([...itemsList, emptyProductItem]);
      } else {
        setItemsList([...itemsList, emptyLiveItem]);
      }

      console.log('itemsList change', itemsList);
    };

    const change = (draggedIndex: number, hoveredIndex: number) => {
      // update title deepLink and liveText
      for (const key in changeTitleItems) {
        const currentIndex = parseInt(key);
        itemsList[currentIndex].deepLink =
          changeTitleItems[currentIndex].deepLink;
        itemsList[currentIndex].title = changeTitleItems[currentIndex].title;
        itemsList[currentIndex].liveText =
          changeTitleItems[currentIndex].liveText;
      }
      // update itemList url
      for (const [key, value] of Object.entries(changeItems)) {
        const currentIndex = value.itemIndex;
        const isPortrait = value.isPortrait;
        if (isPortrait) {
          itemsList[currentIndex].image.portraitURL = value.src;
        }
        if (!isPortrait) {
          itemsList[currentIndex].image.squarishURL = value.src;
        }
      }

      const newChangeItems: Record<string, ChangeItems> = {};

      const maxIndex =
        draggedIndex > hoveredIndex ? draggedIndex : hoveredIndex;
      const minIndex =
        draggedIndex < hoveredIndex ? draggedIndex : hoveredIndex;

      // if abs == 1 replace with each other
      if (Math.abs(draggedIndex - hoveredIndex) === 1) {
        for (const key in changeItems) {
          const changeIndex = changeItems[key].itemIndex;
          if (changeIndex === maxIndex) {
            const newKey = key.replace(changeIndex + '', minIndex + '');
            newChangeItems[newKey] = changeItems[key];
            newChangeItems[newKey].itemIndex = minIndex;
          } else if (changeIndex === minIndex) {
            const newKey = key.replace(changeIndex + '', maxIndex + '');
            newChangeItems[newKey] = changeItems[key];
            newChangeItems[newKey].itemIndex = maxIndex;
          } else {
            newChangeItems[key] = changeItems[key];
          }
        }
      }
      // drag is less than hover, every index should minus one before hover
      else if (draggedIndex < hoveredIndex) {
        for (const key in changeItems) {
          const changeIndex = changeItems[key].itemIndex;
          if (changeIndex > minIndex && changeIndex <= maxIndex) {
            const newKey = key.replace(changeIndex + '', changeIndex - 1 + '');
            newChangeItems[newKey] = changeItems[key];
            newChangeItems[newKey].itemIndex = changeIndex + 1;
          } else if (changeIndex === minIndex) {
            const newKey = key.replace(changeIndex + '', maxIndex + '');
            newChangeItems[newKey] = changeItems[key];
            newChangeItems[newKey].itemIndex = maxIndex;
          } else {
            newChangeItems[key] = changeItems[key];
          }
        }
      }
      // drag is more than hover, every index should plus one after hover
      else if (draggedIndex > hoveredIndex) {
        for (const key in changeItems) {
          const changeIndex = changeItems[key].itemIndex;
          if (changeIndex >= minIndex && changeIndex < maxIndex) {
            const newKey = key.replace(changeIndex + '', changeIndex + 1 + '');
            newChangeItems[newKey] = changeItems[key];
            newChangeItems[newKey].itemIndex = changeIndex + 1;
          } else if (changeIndex === maxIndex) {
            const newKey = key.replace(changeIndex + '', minIndex + '');
            newChangeItems[newKey] = changeItems[key];
            newChangeItems[newKey].itemIndex = minIndex;
          } else {
            newChangeItems[key] = changeItems[key];
          }
        }
      }

      console.log('after drag:', newChangeItems);
      setChangeItems(newChangeItems);

      const fromIndex = draggedIndex;
      const toIndex = hoveredIndex;

      // take out move element
      const elementToMove = itemsList.splice(fromIndex, 1)[0];

      // insert
      itemsList.splice(toIndex, 0, elementToMove);

      setItemsList(itemsList);
      setChangeTitleItems({});
    };
    return (
      <>
        <div className='tw-flex tw-gap-8 tw-mt-4 tw-h-30'>
          <span
            style={{ padding: '10px' }}
            className='tw-h-10 tw-w-14 tw-flex tw-gap-1'
          >
            <span>Items</span>
            <Tooltip
              bodySlot={'drag item to change order'}
              placement={'bottom'}
              enableFocus
            >
              <Icon name='InfoCircle' size='s'></Icon>
            </Tooltip>
          </span>

          <div
            className='tw-flex tw-flex-col tw-overflow-scroll tw-gap-1 tw-h-45 tw-w-full'
            id='Items'
          >
            {itemsList.map((item, itemIndex) => {
              if (!item.isLive || item.isAddPortrait) {
                return (
                  <div
                    key={crypto.randomUUID()}
                    className='tw-cursor-pointer'
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData('text/plain', itemIndex + '')
                    }
                    onDragEnter={(e) => e.preventDefault()}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      const draggedIndex = parseInt(
                        e.dataTransfer.getData('text/plain'),
                      );
                      const hoveredIndex = itemIndex;
                      if (draggedIndex === hoveredIndex) {
                        return;
                      }
                      change(draggedIndex, hoveredIndex);
                    }}
                  >
                    <RankingListPortraitItem
                      item={item}
                      key={itemIndex}
                      itemIndex={itemIndex}
                      portraitItemChange={portraitItemChange}
                      portraitTitleAndDeepLinkChange={
                        portraitTitleAndDeepLinkChange
                      }
                      squarishTitleAndDeepLinkAndLiveTextChange={
                        squarishTitleAndDeepLinkAndLiveTextChange
                      }
                      handleDeleteItem={handleDeleteItem}
                    />
                  </div>
                );
              } else {
                return (
                  <div
                    key={crypto.randomUUID()}
                    className='tw-cursor-pointer'
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData('text/plain', itemIndex + '')
                    }
                    onDragEnter={(e) => e.preventDefault()}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      const draggedIndex = parseInt(
                        e.dataTransfer.getData('text/plain'),
                      );
                      const hoveredIndex = itemIndex;
                      if (draggedIndex === hoveredIndex) {
                        return;
                      }
                      change(draggedIndex, hoveredIndex);
                    }}
                  >
                    <RankingListSquarishItem
                      item={item}
                      key={itemIndex}
                      itemIndex={itemIndex}
                      portraitItemChange={portraitItemChange}
                      portraitTitleAndDeepLinkChange={
                        portraitTitleAndDeepLinkChange
                      }
                      squarishTitleAndDeepLinkAndLiveTextChange={
                        squarishTitleAndDeepLinkAndLiveTextChange
                      }
                      handleDeleteItem={handleDeleteItem}
                    />
                  </div>
                );
              }
            })}
            <div>
              <div className='tw-flex tw-gap-2'>
                <div
                  id='add'
                  className='tw-text-lg tw-text-center tw-border tw-flex-col tw-border-solid hover:tw-cursor-pointer  tw-w-1/2 tw-select-none'
                  style={{
                    borderColor: 'var(--eds-color-grey-2)',
                    padding: '5px',
                    borderRadius: 'var(--eds-radii-4)',
                    backgroundColor: '#36be1824',
                  }}
                  onClick={() => {
                    addItem(true);
                  }}
                >
                  <span className='tw-font-sans tw-text-sm tw-font-medium tw-flex tw-text-center tw-justify-center  tw-gap-1 tw-items-center tw-relative'>
                    <span className='mt-1'>
                      <ImageSvgIcon />
                    </span>
                    <span className='tw-mt-[0.2rem]'>Add Image</span>
                  </span>
                </div>
                <div
                  id='add'
                  className='tw-text-lg tw-text-center tw-border tw-flex-col tw-border-solid hover:tw-cursor-pointer  tw-w-1/2 tw-select-none'
                  style={{
                    borderColor: 'var(--eds-color-grey-2)',
                    padding: '5px',
                    borderRadius: 'var(--eds-radii-4)',
                    backgroundColor: 'rgb(59 130 246 / 11%)',
                  }}
                  onClick={() => {
                    addItem(false);
                  }}
                >
                  {/* <span className='tw-font-sans tw-text-sm tw-font-medium'> Add Live Text</span> */}
                  <span
                    className='tw-font-sans tw-text-sm tw-font-medium tw-flex tw-text-center tw-justify-center  tw-gap-1 tw-items-center tw-relative tw-h-full'
                    style={{}}
                  >
                    <span>
                      <TextSvgIcon />
                    </span>
                    <span className='tw-mt-[0.2rem]'>Add Live Text</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  },
);

function RankingListPortraitItem(props: RankingListPreviewItemProps) {
  const item: RankingItem | null = props?.item;
  const [portraitTitle, setPortraitTitle] = useState(item?.title);
  const [portraitDeepLink, setPortraitDeepLink] = useState(item?.deepLink);

  const titleId = 'titleId-' + props.itemIndex;
  const deepLinkId = 'deepLinkId-' + props.itemIndex;

  const titleRef = useRef<HTMLInputElement>(null);
  const deepLinkRef = useRef<HTMLInputElement>(null);

  const [titleErrorMsg, setTitleErrorMsg] = useState('');
  const [titleError, setTitleError] = useState(false);

  const [deepLinkErrorMsg, seDeepLinkErrorMsg] = useState('');
  const [deepLinkError, setDeepLinkError] = useState(false);

  const onTitleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPortraitTitle(e.target.value);
    setTitleError(e.target.value.length > 0 ? false : true);
    if (e.target.value.length < 1) {
      setTitleError(true);
      setTitleErrorMsg('title is empty');
    }
    props.portraitTitleAndDeepLinkChange(
      e.target.value,
      deepLinkRef.current?.value as string,
      props.itemIndex,
    );
  };

  const onDeepLinkChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPortraitDeepLink(e.target.value);
    setDeepLinkError(e.target.value.length > 0 ? false : true);
    if (e.target.value.length < 1) {
      setDeepLinkError(true);
      seDeepLinkErrorMsg('deepLink is empty');
    }
    props.portraitTitleAndDeepLinkChange(
      titleRef.current?.value as string,
      e.target.value,
      props.itemIndex,
    );
  };

  /*** change items index portraitUrl or live  */
  const portraitItemChange = (
    image: UploadFileType | null,
    isPortrait: boolean,
    itemIndex: number,
    src: string,
  ) => {
    props.portraitItemChange(image, isPortrait, itemIndex, src);
  };

  const handleDeleteItem = () => {
    props.handleDeleteItem(props.itemIndex);
  };

  return (
    <>
      <div>
        <div
          className='tw-border tw-flex-col tw-shadow-sm tw-mt-1'
          style={{
            borderColor: 'var(--eds-color-grey-2)',
            borderRadius: 'var(--eds-radii-4)',
          }}
        >
          <div className='tw-flex tw-flex-col tw-relative'>
            {/* 左边的序号 */}
            <div className='tw-absolute tw-top-[2px] tw-left-[2px] tw-flex tw-items-center tw-justify-center'>
              <div
                className='tw-rounded-full tw-bg-gray-300 tw-text-center tw-bg-primary tw-rounded-pill'
                style={{
                  padding: '2px 5px',
                  fontSize: '.7rem',
                  lineHeight: 1,
                  textAlign: 'center',
                  paddingLeft: '5px',
                  paddingRight: '5px',
                  whiteSpace: 'nowrap',
                }}
              >
                {props.itemIndex + 1}
              </div>
            </div>
            {/* 右边的delete */}
            <div
              className='tw-absolute tw-right-[2.5px] tw-flex tw-items-center tw-justify-center tw-top-1/2'
              style={{ transform: 'translateY(-50%)' }}
              onClick={handleDeleteItem}
            >
              <Tooltip bodySlot='delete' enableFocus>
                <IconButton
                  icon={<Icon name='Delete' size='s' color='red' />}
                  variant='secondary'
                  size='small'
                  disableRipple={true}
                  label='Delete'
                />
              </Tooltip>
            </div>
            {/* up two pictures */}
            <div className='tw-flex tw-gap-[5rem]'>
              <div className='tw-flex tw-gap-2 tw-mt-2'>
                <span
                  className='tw-h-10 tw-w-[100px] tw-mt-10'
                  style={{ padding: '10px' }}
                >
                  Image
                </span>
                <div className='tw-flex-col tw-text-center'>
                  <ImageUploader
                    imageSrc={item?.image.portraitURL}
                    imageChange={portraitItemChange}
                    itemIndex={props.itemIndex}
                    isPortrait={true}
                  />
                  <span style={{ fontSize: 13, fontWeight: 400 }}>
                    Portrait
                  </span>
                </div>
              </div>
              <div className='tw-text-center  tw-mt-2'>
                <ImageUploader
                  imageSrc={item?.image.squarishURL}
                  imageChange={portraitItemChange}
                  itemIndex={props.itemIndex}
                  isPortrait={false}
                />
                <span style={{ fontSize: 13, fontWeight: 400 }}>Squarish</span>
              </div>
            </div>
            {/* 下面的 title 和 deeplink */}
            <div className='tw-flex tw-flex-col'>
              <div className='tw-flex tw-gap-2 tw-mt-2'>
                <label
                  htmlFor='title'
                  style={{ padding: '10px' }}
                  className='tw-h-10 tw-w-[100px] tw-border'
                >
                  Title
                </label>
                <TextField
                  className='tw-w-[24rem] tw-rounded-3xl tw-h-10  tw-font-bold'
                  id={titleId}
                  ref={titleRef}
                  hideLabel
                  label='tokenizer'
                  onChange={onTitleChange}
                  value={portraitTitle}
                  hasErrors={titleError}
                  errorMessage={titleErrorMsg}
                />
              </div>
              <div className='tw-flex tw-gap-2 tw-mb-5 tw-mt-3'>
                <label
                  htmlFor='DeepLink'
                  style={{ padding: '10px' }}
                  className='tw-h-10 tw-w-[100px] tw-border'
                >
                  DeepLink
                </label>
                <TextField
                  className='tw-w-[24rem] tw-rounded-3xl tw-h-10  tw-font-bold'
                  id={deepLinkId}
                  hideLabel
                  ref={deepLinkRef}
                  label='tokenizer'
                  value={portraitDeepLink}
                  onChange={onDeepLinkChange}
                  hasErrors={deepLinkError}
                  errorMessage={deepLinkErrorMsg}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function RankingListSquarishItem(props: RankingListPreviewItemProps) {
  const item: RankingItem | null = props?.item;

  const [squarishTitle, setSquarishTitle] = useState(item?.title);
  const [squarishDeepLink, setSquarishDeepLink] = useState(item?.deepLink);
  const [squarishLiveText, setSquarishLiveText] = useState(item?.liveText);

  const titleRef = useRef<HTMLInputElement>(null);
  const deepLinkRef = useRef<HTMLInputElement>(null);
  const liveTextkRef = useRef<HTMLInputElement>(null);

  const titleId = 'Squarish-titleId-' + props.itemIndex;
  const deepLinkId = 'Squarish-deepLinkId-' + props.itemIndex;
  const liveTextId = 'Squarish-deepLinkId-' + props.itemIndex;

  const handleDeleteItem = () => {
    props.handleDeleteItem(props.itemIndex);
  };

  const [titleErrorMsg, setTitleErrorMsg] = useState('');
  const [titleError, setTitleError] = useState(false);

  const [liveTextErrorMsg, setLiveTextErrorMsg] = useState('');
  const [liveTextError, setLiveTextError] = useState(false);

  const [deepLinkErrorMsg, seDeepLinkErrorMsg] = useState('');
  const [deepLinkError, setDeepLinkError] = useState(false);

  const onLiveTextChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSquarishLiveText(e.target.value);
    setLiveTextError(e.target.value.length > 0 ? false : true);
    if (e.target.value.length < 1) {
      setLiveTextError(true);
      setLiveTextErrorMsg('live text is empty');
    }
    props.squarishTitleAndDeepLinkAndLiveTextChange(
      titleRef.current?.value as string,
      deepLinkRef.current?.value as string,
      e.target.value,
      props.itemIndex,
    );
  };

  const onTitleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSquarishTitle(e.target.value);
    setTitleError(e.target.value.length > 0 ? false : true);
    if (e.target.value.length < 1) {
      setTitleError(true);
      setTitleErrorMsg('title is empty');
    }
    props.squarishTitleAndDeepLinkAndLiveTextChange(
      e.target.value,
      deepLinkRef.current?.value as string,
      liveTextkRef.current?.value as string,
      props.itemIndex,
    );
  };

  const onDeepLinkChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDeepLinkError(e.target.value.length > 0 ? false : true);
    if (e.target.value.length < 1) {
      setDeepLinkError(true);
      seDeepLinkErrorMsg('deepLink is empty');
    }
    setSquarishDeepLink(e.target.value);
    props.squarishTitleAndDeepLinkAndLiveTextChange(
      titleRef.current?.value as string,
      e.target.value,
      liveTextkRef.current?.value as string,
      props.itemIndex,
    );
  };

  return (
    <>
      <div>
        <div
          className='tw-border tw-flex-col tw-shadow-sm tw-relative tw-mt-1'
          style={{
            borderColor: 'var(--eds-color-grey-2)',
            borderRadius: 'var(--eds-radii-4)',
          }}
        >
          {/* 左边的序号 */}
          <div className='tw-absolute tw-top-[2px] tw-left-[2px] tw-flex tw-items-center tw-justify-center'>
            <div
              className='tw-rounded-full tw-bg-gray-300 tw-text-center tw-bg-primary tw-rounded-pill'
              style={{
                padding: '2px 5px',
                fontSize: '.7rem',
                lineHeight: 1,
                textAlign: 'center',
                paddingLeft: '5px',
                paddingRight: '5px',
                whiteSpace: 'nowrap',
              }}
            >
              {props.itemIndex + 1}
            </div>
          </div>
          <div
            className='tw-absolute tw-right-[2.5px]  tw-flex tw-items-center tw-justify-center tw-top-1/2'
            style={{ transform: 'translateY(-50%)' }}
            onClick={handleDeleteItem}
          >
            <Tooltip bodySlot='delete' enableFocus>
              <IconButton
                icon={<Icon name='Delete' size='s' color='red' />}
                variant='secondary'
                size='small'
                disableRipple={true}
                label='Delete'
              />
            </Tooltip>
          </div>
          <div className='tw-flex tw-flex-col'>
            {/* 下面的 live-text title 和 deeplink */}
            {/* live text */}
            <div className='tw-flex tw-gap-2 tw-mt-4'>
              <label
                htmlFor='DeepLink'
                style={{ padding: '10px' }}
                className='tw-h-10 tw-w-[100px] tw-border'
              >
                Live Text
              </label>
              <TextField
                className='tw-w-[24rem] tw-rounded-3xl tw-h-10  tw-font-bold'
                id={liveTextId}
                hideLabel
                label='tokenizer'
                value={squarishLiveText}
                onChange={onLiveTextChange}
                errorMessage={liveTextErrorMsg}
                hasErrors={liveTextError}
                ref={liveTextkRef}
              />
            </div>

            {/* Title */}
            <div className='tw-flex tw-gap-2 tw-mt-3'>
              <span
                style={{ padding: '10px' }}
                className='tw-h-10 tw-w-[100px] tw-border'
              >
                Title
              </span>
              <TextField
                className='tw-w-[24rem] tw-rounded-3xl tw-h-10  tw-font-bold'
                id={titleId}
                hideLabel
                errorMessage={titleErrorMsg}
                hasErrors={titleError}
                label='tokenizer'
                value={squarishTitle}
                onChange={onTitleChange}
                ref={titleRef}
              />
            </div>

            {/* DeepLink */}
            <div className='tw-flex tw-gap-2 tw-w-full tw-mb-5  tw-mt-3 '>
              <span
                style={{ padding: '10px' }}
                className='tw-h-10 tw-w-[100px] tw-border'
              >
                DeepLink
              </span>
              <TextField
                className='tw-w-[24rem] tw-rounded-3xl tw-h-10  tw-font-bold'
                id={deepLinkId}
                hideLabel
                label='tokenizer'
                value={squarishDeepLink}
                onChange={onDeepLinkChange}
                errorMessage={deepLinkErrorMsg}
                hasErrors={deepLinkError}
                ref={deepLinkRef}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

class ImageUploader extends React.Component<
  ImageUploaderProps,
  ImageUploaderState
> {
  constructor(props: ImageUploaderProps) {
    super(props);
    this.state = {
      imageSrc: props.imageSrc,
      displayDelete: true,
    };
  }

  private fileInputRef: RefObject<HTMLInputElement> = React.createRef();
  private imageInputRef: RefObject<HTMLImageElement> = React.createRef();

  handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files || event.target.files.length === 0) return;
    // 1、generate uuid

    // 2、according to uuid and  styleColor get url
    //return useMutation((params: { styleColor: string; imageIds: string[] }) => {
    //   return genPreSignedUrls(loaderData.access_token, params);
    // });

    // 3、upload image uploadImage(url, pendingImg.file)
    const file = event.target.files[0];
    const currentFile = {
      files: event.target.files,
      id:
        crypto.randomUUID() +
        '.' +
        file.name.split('.')[file.name.split('.').length - 1],
    };
    const reader = new FileReader();
    reader.onloadend = () => {
      const imageResult = reader.result as string;
      this.setState({ imageSrc: imageResult });
      if (this.imageInputRef.current) {
        this.imageInputRef.current.src = reader.result as string;
      }
      this.props.imageChange(
        currentFile,
        this.props.isPortrait,
        this.props.itemIndex,
        imageResult,
      );
    };
    reader.readAsDataURL(file);
  };

  handleImageDelete = () => {
    this.setState({ imageSrc: null }, () => {
      console.log('after delete', this.state.imageSrc);
    });
    if (this.imageInputRef.current) {
      this.imageInputRef.current.src = '';
    }

    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
    this.props.imageChange(
      null,
      this.props.isPortrait,
      this.props.itemIndex,
      '',
    );
  };

  render(): React.ReactNode {
    const urlSuffix = this.props.isPortrait ? '-portrait-' : '-squarish-';
    const upload_id = 'upload-input' + urlSuffix + this.props.itemIndex;
    return (
      <div
        className='tw-w-[150px] tw-h-[150px] tw-border-2 tw-cursor-pointer hover:tw-bg-gray-100 tw-flex tw-items-center tw-justify-center tw-relative tw-mt-2'
        style={{ borderStyle: this.state.imageSrc ? 'thin dashed' : 'dashed' }}
        title='Click to delete image'
        onClick={
          this.state.imageSrc
            ? this.handleImageDelete
            : () => document.getElementById(upload_id)?.click()
        }
        onMouseEnter={() => {
          this.setState({ displayDelete: false });
        }}
        onMouseLeave={() => {
          this.setState({ displayDelete: true });
        }}
      >
        <TextField
          id={upload_id}
          label='tokenizer'
          hideLabel
          type='file'
          onChange={this.handleImageChange}
          hidden
          ref={this.fileInputRef}
        />

        {!this.state.imageSrc && (
          <div className='tw-text-4xl tw-text-gray-400'>+</div>
        )}

        {this.state.imageSrc && (
          <img
            className='tw-w-full tw-h-full tw-object-cover'
            alt='Uploaded'
            src={this.state.imageSrc}
            ref={this.imageInputRef}
          />
        )}

        {this.state.imageSrc && (
          <div
            className='tw-absolute tw-top-0 tw-right-0 tw-text-white tw-tw-opacity-0 
              group-hover:tw-opacity-100 tw-transition  tw-duration-200 tw-ease-in-out'
            hidden={this.state.displayDelete}
          >
            <IconButton
              className='tw-h-3 tw-w-3'
              onClick={this.handleImageDelete}
              icon={<Icon name='Delete' size='m' />}
              variant='ghost'
              size='small'
              disableRipple={true}
              label='Delete'
            />
          </div>
        )}
      </div>
    );
  }
}

function ImageSvgIcon() {
  return (
    <svg
      className='icon'
      viewBox='0 0 1024 1024'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
    >
      <path
        d='M145.6 0c-44.8 0-80 36.8-80 81.6V944c0 44.8 35.2 80 80 80h732.8c44.8 0 81.6-35.2 81.6-80V326.4L657.6 0h-512z'
        fill='#49C9A7'
      ></path>
      <path
        d='M960 326.4v16H755.2s-100.8-20.8-99.2-108.8c0 0 4.8 92.8 97.6 92.8H960z'
        fill='#37BB91'
      ></path>
      <path
        d='M657.6 0v233.6c0 25.6 17.6 92.8 97.6 92.8H960L657.6 0z'
        fill='#FFFFFF'
      ></path>
      <path
        d='M225.6 859.2V524.8H560v334.4H225.6z m300.8-300.8H259.2v201.6h267.2V558.4z m-153.6 134.4l62.4-84.8 20.8 33.6 20.8-6.4 16 89.6H283.2l56-52.8 33.6 20.8z m-60.8-59.2c-14.4 0-27.2-9.6-27.2-24 0-12.8 12.8-24 27.2-24 14.4 0 25.6 11.2 25.6 24 0 14.4-11.2 24-25.6 24z'
        fill='#FFFFFF'
      ></path>
    </svg>
  );
}

function TextSvgIcon() {
  return (
    <svg
      className='icon'
      viewBox='0 0 1024 1024'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
    >
      <path
        d='M886.624 297.376l-191.968-191.968c-2.944-2.944-6.432-5.312-10.336-6.912C680.48 96.864 676.288 96 672 96L224 96C171.072 96 128 139.072 128 192l0 640c0 52.928 43.072 96 96 96l576 0c52.928 0 96-43.072 96-96L896 320C896 311.52 892.64 303.36 886.624 297.376zM704 205.248 818.752 320 704 320 704 205.248zM800 864 224 864c-17.632 0-32-14.336-32-32L192 192c0-17.632 14.368-32 32-32l416 0 0 192c0 17.664 14.304 32 32 32l160 0 0 448C832 849.664 817.664 864 800 864z'
        fill='#5D646F'
      ></path>
      <path
        d='M288 352l192 0c17.664 0 32-14.336 32-32s-14.336-32-32-32L288 288c-17.664 0-32 14.336-32 32S270.336 352 288 352z'
        fill='#5D646F'
      ></path>
      <path
        d='M608 480 288 480c-17.664 0-32 14.336-32 32s14.336 32 32 32l320 0c17.696 0 32-14.336 32-32S625.696 480 608 480z'
        fill='#5D646F'
      ></path>
      <path
        d='M608 672 288 672c-17.664 0-32 14.304-32 32s14.336 32 32 32l320 0c17.696 0 32-14.304 32-32S625.696 672 608 672z'
        fill='#5D646F'
      ></path>
    </svg>
  );
}

// memo is only when RankingListItem changed, will reload child component
export default memo(RankingListItem);
